import React, { Fragment, useState } from "react";
import { VerticalTimelineElement } from "react-vertical-timeline-component";
import styled from "@mui/system/styled";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LinearProgress from "@mui/material/LinearProgress";
import "react-vertical-timeline-component/style.min.css";

import step_01 from "../assets/Step_01.png";
import step_02 from "../assets/Step_02.png";
import step_03 from "../assets/Step_03.png";
import step_04 from "../assets/Step_04.png";
import step_05 from "../assets/Step_05.png";
import step_06 from "../assets/Step_06.png";
import step_07 from "../assets/Step_07.png";
import step_08 from "../assets/Step_08.png";
import step_18 from "../assets/Step_18.png";
import step_19 from "../assets/Step_19.png";
import step_20 from "../assets/Step_20.png";
import step_01g from "../assets/Step_01g.png";
import step_02g from "../assets/Step_02g.png";
import step_03g from "../assets/Step_03g.png";
import step_04g from "../assets/Step_04g.png";
import step_05g from "../assets/Step_05g.png";
import step_06g from "../assets/Step_06g.png";
import step_07g from "../assets/Step_07g.png";
import step_08g from "../assets/Step_08g.png";
import step_18g from "../assets/Step_18g.png";
import step_19g from "../assets/Step_19g.png";
import step_20g from "../assets/Step_20g.png";

const Item = styled("div")(({ theme }) => ({
  borderColor: theme.palette.mode === "dark" ? "#444d58" : "#ced7e0",
  padding: 0,
  borderRadius: "4px",
  a: {
    textDecoration: "none",
    color: "#0072E5",
    "&:hover": {
      background: "#0072E5",
      color: "white",
      textDecoration: "underline",
    },
  },
}));

const iconHistoryStyles = {
  background: "#3cb95f",
  height: "30px",
  width: "30px",
  display: "table",
  marginLeft: "0.5%",
  marginTop: "15px",
};
const iconCurrentStyles = {
  background: "#159ceb",
  height: "30px",
  width: "30px",
  display: "table",
  marginLeft: "0.5%",
  marginTop: "15px",
};
const iconFutureStyles = {
  background: "#b5a6b5",
  height: "30px",
  width: "30px",
  display: "table",
  marginLeft: "0.5%",
  marginTop: "15px",
};

const arrowStyles = { borderRight: "10px solid  rgb(33, 150, 243)" };

const contentFutureStyles = {
  color: "#ccc2cc",
  background: "#ccc2cc",
  fontFamily: "arial,helvetica",
  fontSize: 14,
  boxShadow: "10px 20px 30px darkgrey",
  paddingBottom: 0,
};

const contentCurrentHistoryStyles = {
  color: "#0c0c0c",
  background: "white",
  fontFamily: "arial,helvetica",
  fontSize: 14,
  boxShadow: "10px 20px 30px darkgrey",
  paddingBottom: 0,
};

const elementTitleStyles = {
  color: "#00629b",
  fontFamily: "arial,helvetica",
  fontSize: 16,
};

const elementTitleStylesMobile = {
  color: "#00629b",
  fontFamily: "arial,helvetica",
  fontSize: 14,
};

const elementTitleDateStyles = {
  color: "#0c0c0c",
  fontFamily: "arial,helvetica",
  fontSize: 12,
};

const elementExtraTextStyles = {
  color: "#00629b",
  fontFamily: "arial,helvetica",
  fontSize: 16,
  fontWeight: "bold",
  textAlign: "center",
};
const elementBodyStyles = {
  color: "black",
};

const ImgByName = ({ imgName }) => {
  switch (imgName) {
    case "Step_01.png": {
      return <img src={step_01} alt="" width="40px" height="45px" />;
    }
    case "Step_02.png": {
      return <img src={step_02} alt="" width="40px" height="45px" />;
    }
    case "Step_03.png": {
      return <img src={step_03} alt="" width="40px" height="45px" />;
    }
    case "Step_04.png": {
      return <img src={step_04} alt="" width="40px" height="45px" />;
    }
    case "Step_05.png": {
      return <img src={step_05} alt="" width="40px" height="45px" />;
    }
    case "Step_06.png": {
      return <img src={step_06} alt="" width="40px" height="45px" />;
    }
    case "Step_07.png": {
      return <img src={step_07} alt="" width="40px" height="45px" />;
    }
    case "Step_08.png": {
      return <img src={step_08} alt="" width="40px" height="45px" />;
    }
    case "Step_18.png": {
      return <img src={step_18} alt="" width="40px" height="45px" />;
    }
    case "Step_19.png": {
      return <img src={step_19} alt="" width="40px" height="45px" />;
    }
    case "Step_20.png": {
      return <img src={step_20} alt="" width="40px" height="45px" />;
    }
    case "Step_01g.png": {
      return <img src={step_01g} alt="" width="40px" height="45px" />;
    }
    case "Step_02g.png": {
      return <img src={step_02g} alt="" width="40px" height="45px" />;
    }
    case "Step_03g.png": {
      return <img src={step_03g} alt="" width="40px" height="45px" />;
    }
    case "Step_04g.png": {
      return <img src={step_04g} alt="" width="40px" height="45px" />;
    }
    case "Step_05g.png": {
      return <img src={step_05g} alt="" width="40px" height="45px" />;
    }
    case "Step_06g.png": {
      return <img src={step_06g} alt="" width="40px" height="45px" />;
    }
    case "Step_07g.png": {
      return <img src={step_07g} alt="" width="40px" height="45px" />;
    }
    case "Step_08g.png": {
      return <img src={step_08g} alt="" width="40px" height="45px" />;
    }
    case "Step_18g.png": {
      return <img src={step_18g} alt="" width="40px" height="45px" />;
    }
    case "Step_19g.png": {
      return <img src={step_19g} alt="" width="40px" height="45px" />;
    }
    case "Step_20g.png": {
      return <img src={step_20g} alt="" width="40px" height="45px" />;
    }
    default:
      return null;
  }
};

function VerticalTimelineElementComponent({ elementData, innerRef }) {
  const [nodeExpanded, setNodeExpanded] = useState(elementData.ExpandNode);
  const SetNodeView = () => {
    setNodeExpanded(!nodeExpanded);
  };

  return (
    <Fragment key={elementData.Id}>
      <VerticalTimelineElement
        className="vertical-timeline-element"
        contentStyle={
          elementData.ReasonCode === "FUTR"
            ? contentFutureStyles
            : contentCurrentHistoryStyles
        }
        contentArrowStyle={arrowStyles}
        iconStyle={
          elementData.ReasonCode === "HIST"
            ? iconHistoryStyles
            : elementData.ReasonCode === "CURR"
            ? iconCurrentStyles
            : iconFutureStyles
        }
        icon={
          elementData.ReasonCode === "CURR" ? (
            nodeExpanded ? (
              <RemoveIcon />
            ) : (
              <AddIcon />
            )
          ) : null
        }
        key={elementData.Id}
        iconOnClick={() => {
          if (elementData.ReasonCode === "CURR") SetNodeView();
        }}
      >
        {nodeExpanded ? (
          <Fragment>
            <Box sx={{ display: { xs: "block", md: "none" } }} ref={innerRef}>
              <Grid container spacing={1} paddingBottom="0">
                <Grid item>
                  <Item align="center" style={elementTitleDateStyles}>
                    <ImgByName imgName={elementData.StepImage} />
                    <br />
                  </Item>
                </Grid>
                <Grid
                  item
                  xs={10}
                  alignItems="center"
                  container
                  direction="row"
                  justify="flex-end"
                  paddingBottom="0"
                >
                  <Item>
                    <h3
                      className="vertical-timeline-element-title"
                      style={elementTitleStyles}
                    >
                      {elementData.ProcessDescription}
                    </h3>
                  </Item>
                </Grid>
                {elementData?.IsHeader === false ? (
                  <Fragment>
                    <Grid item xs={12}>
                      <Item>
                        <Item>
                          <p
                            className="vertical-timeline-element-subtitle"
                            style={elementBodyStyles}
                            dangerouslySetInnerHTML={{
                              __html: elementData.ReasonDescription,
                            }}
                          ></p>
                          <br />
                          {elementData.ReasonDescriptionExtraText !== "" ? (
                            <Fragment>
                              <br />
                              <p style={elementExtraTextStyles}>
                                {elementData.ReasonDescriptionExtraText}
                              </p>
                            </Fragment>
                          ) : null}
                        </Item>
                        <br />
                      </Item>
                    </Grid>
                    <Grid item xs={12}>
                      <LinearProgress
                        variant="determinate"
                        value={parseInt(elementData.PercentageComplete)}
                      />
                    </Grid>
                  </Fragment>
                ) : (
                  <Grid item xs={12}>
                    <Item>
                      <p
                        className="vertical-timeline-element-subtitle"
                        style={elementBodyStyles}
                        dangerouslySetInnerHTML={{
                          __html: elementData.ReasonDescription,
                        }}
                      ></p>
                    </Item>
                  </Grid>
                )}
                <Grid
                  item
                  container
                  xs={6}
                  wrap="nowwrap"
                  alignItems="center"
                  direction="row"
                  justify="flex-end"
                  padding={0}
                >
                  <Grid item xs={3}>
                    <CalendarMonthIcon sx={{ fontSize: 30 }} />
                  </Grid>
                  <Grid item xs={9} sx={{ fontSize: 12, fontWeight: "bold" }}>
                    {elementData.DateTimeCreated}
                  </Grid>
                </Grid>
                <Grid
                  item
                  container
                  align="right"
                  xs={6}
                  wrap="nowrap"
                  alignItems="center"
                  direction="row"
                  justify="flex-end"
                >
                  {elementData.DateTimeFinalised === "SLA Expired" ? (
                    <Grid
                      container
                      item
                      xs={6}
                      alignItems="center"
                      direction="row"
                      justifyContent={"flex-end"}
                      sx={{
                        color: "#C00000",
                        fontWeight: "bold",
                      }}
                    >
                      <AccessTimeIcon sx={{ fontSize: 40, color: "#C00000" }} />
                      {elementData.DateTimeFinalised}
                    </Grid>
                  ) : (
                    <Fragment>
                      <Grid
                        container
                        item
                        xs={6}
                        alignItems="center"
                        direction="row"
                        justifyContent={"flex-end"}
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        {elementData.DateTimeFinalised !== "" ? (
                          <AccessTimeIcon sx={{ fontSize: 40 }} />
                        ) : null}
                        {elementData.DateTimeFinalised}
                      </Grid>
                    </Fragment>
                  )}
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ display: { xs: "none", md: "block" } }} ref={innerRef}>
              <Grid container spacing={1} paddingBottom="0">
                <Grid item>
                  <Item align="center" style={elementTitleDateStyles}>
                    <ImgByName imgName={elementData.StepImage} />
                    <br />
                  </Item>
                </Grid>
                <Grid
                  item
                  md={10}
                  alignItems="center"
                  container
                  direction="row"
                  justify="flex-end"
                >
                  <Item>
                    <h3
                      className="vertical-timeline-element-title"
                      style={elementTitleStyles}
                    >
                      {elementData.ProcessDescription}
                    </h3>
                  </Item>
                </Grid>
                {elementData?.IsHeader === false ? (
                  <Fragment>
                    <Grid item md={12}>
                      <Item>
                        <Item>
                          <p
                            className="vertical-timeline-element-subtitle"
                            style={elementBodyStyles}
                            dangerouslySetInnerHTML={{
                              __html: elementData.ReasonDescription,
                            }}
                          ></p>
                          <br />

                          {elementData.ReasonDescriptionExtraText !== "" ? (
                            <Fragment>
                              <br />
                              <p style={elementExtraTextStyles}>
                                {elementData.ReasonDescriptionExtraText}
                              </p>
                            </Fragment>
                          ) : null}
                        </Item>
                        <br />
                      </Item>
                    </Grid>
                    <Grid item md={12}>
                      <LinearProgress
                        variant="determinate"
                        value={parseInt(elementData.PercentageComplete)}
                      />
                    </Grid>
                  </Fragment>
                ) : (
                  <Grid item md={12}>
                    <Item>
                      <p
                        className="vertical-timeline-element-subtitle"
                        style={elementBodyStyles}
                        dangerouslySetInnerHTML={{
                          __html: elementData.ReasonDescription,
                        }}
                      ></p>
                    </Item>
                  </Grid>
                )}
                <Grid
                  item
                  container
                  md={6}
                  alignItems="center"
                  direction="row"
                  justifyContent={"flex-start"}
                  sx={{ fontWeight: "bold" }}
                >
                  <CalendarMonthIcon sx={{ fontSize: 40 }} />
                  {elementData.DateTimeCreated}
                </Grid>
                {/*                 <Grid
                  item
                  container
                  md={8}
                  alignItems="center"
                  direction="row"
                  justifyContent={"flex-start"}
                  sx={{ fontWeight: "bold" }}
                > */}
                {elementData.DateTimeFinalised === "SLA Expired" ? (
                  <Grid
                    container
                    item
                    xs={6}
                    alignItems="center"
                    direction="row"
                    justifyContent={"flex-end"}
                    sx={{
                      color: "#C00000",
                      fontWeight: "bold",
                    }}
                  >
                    <AccessTimeIcon sx={{ fontSize: 40 }} />
                    {elementData.DateTimeFinalised}
                  </Grid>
                ) : (
                  <Grid
                    container
                    item
                    xs={6}
                    alignItems="center"
                    direction="row"
                    justifyContent={"flex-end"}
                    sx={{
                      fontWeight: "bold",
                    }}
                  >
                    {elementData.DateTimeFinalised !== "" ? (
                      <AccessTimeIcon sx={{ fontSize: 40 }} />
                    ) : null}
                    {elementData.DateTimeFinalised}
                  </Grid>
                )}
              </Grid>
              {/* </Grid> */}
            </Box>
          </Fragment>
        ) : (
          <Fragment>
            <Box sx={{ display: { xs: "block", md: "none" } }} ref={innerRef}>
              <Grid container spacing={1}>
                <Grid item>
                  <Item align="center" style={elementTitleDateStyles}>
                    <ImgByName imgName={elementData.StepImage} />
                    <br />
                  </Item>
                </Grid>
                <Grid
                  item
                  xs={9}
                  alignItems="center"
                  container
                  direction="row"
                  justify="flex-end"
                >
                  <Item>
                    <h3
                      className="vertical-timeline-element-title"
                      style={elementTitleStylesMobile}
                    >
                      {elementData.ProcessDescription}
                    </h3>
                  </Item>
                </Grid>
                <Grid
                  item
                  xs={5}
                  alignItems="center"
                  container
                  direction="row"
                  justify="flex-end"
                  sx={{ fontSize: 12, fontWeight: "bold" }}
                >
                  {
                    /* elementData?.ReasonCode === "HIST" && */
                    elementData?.DateTimeCreated !== "" ? (
                      <Fragment>
                        <CalendarMonthIcon sx={{ fontSize: 30 }} />
                        {elementData.DateTimeCreated}
                      </Fragment>
                    ) : null
                  }
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ display: { xs: "none", md: "block" } }} ref={innerRef}>
              <Grid container spacing={1}>
                <Grid item>
                  <Item align="center" style={elementTitleDateStyles}>
                    <ImgByName imgName={elementData.StepImage} />
                    <br />
                  </Item>
                </Grid>
                <Grid
                  item
                  xs={9}
                  alignItems="center"
                  container
                  direction="row"
                  justify="flex-end"
                >
                  <h3
                    className="vertical-timeline-element-title"
                    style={elementTitleStyles}
                  >
                    {elementData.ProcessDescription}
                  </h3>
                </Grid>
                <Grid
                  item
                  xs={2}
                  alignItems="center"
                  container
                  direction="row"
                  justify="flex-end"
                  wrap="nowrap"
                  sx={{ fontWeight: "bold" }}
                >
                  {
                    /* elementData?.ReasonCode === "HIST" && */
                    elementData?.DateTimeCreated !== "" ? (
                      <Fragment>
                        <CalendarMonthIcon sx={{ fontSize: 40 }} />
                        {elementData.DateTimeCreated}
                      </Fragment>
                    ) : null
                  }
                </Grid>
              </Grid>
            </Box>
          </Fragment>
        )}
      </VerticalTimelineElement>
    </Fragment>
  );
}
export default VerticalTimelineElementComponent;
